<script setup lang="ts">
interface FooterColumn {
  title: string;
  links: { label: string; to?: string; href?: string }[];
}

const columns: FooterColumn[] = [
  {
    title: '专区',
    links: [
      { label: '人工智能专区', to: '/zones/ai' },
      { label: '开源法律话题专区', to: '/zones/legal-topics' },
      { label: '沙龙活动专区', to: '/zones/salons' },
      { label: '开放原子系列许可证专区', to: '/zones/licenses' },
      { label: '译文专区', to: '/zones/translations' },
      { label: '提问讨论版', to: '/questions' },
    ],
  },
  {
    title: '资源',
    links: [
      { label: '司法案例库', to: '/cases' },
      { label: '开源法律课程', to: '/courses' },
      { label: '社区资讯', to: '/news' },
      { label: '贡献者库', to: '/experts' },
    ],
  },
  {
    title: '关于',
    links: [
      { label: '社区行为守则', to: '/policy/code-of-conduct' },
      { label: '开放原子开源基金会', href: 'https://openatom.cn' },
      { label: '联系我们', href: 'mailto:legal@openatom.org' },
    ],
  },
];
</script>

<template>
  <footer class="bg-(--footer-bg) text-(--footer-text) pt-11 pb-6">
    <div class="container-main pb-safe">
      <div class="grid grid-cols-2 gap-8 md:grid-cols-[2fr_1fr_1fr_1fr] md:gap-8 mb-7">
        <!-- 品牌 -->
        <div class="col-span-2 md:col-span-1 max-w-[280px]">
          <div class="text-base font-bold text-(--footer-text-strong) mb-3 tracking-[-0.3px]">FOSS LEGAL</div>
          <p class="text-xs text-(--footer-text-dim) leading-[1.8]">
            开放原子开源基金会推荐的中立、开放、专业的开源法律社区，构建开源法律知识生态。
          </p>
        </div>

        <!-- 链接列 -->
        <div v-for="col in columns" :key="col.title">
          <h4 class="text-[11px] font-semibold text-(--footer-text) uppercase tracking-[2px] mb-3">
            {{ col.title }}
          </h4>
          <ul class="flex flex-col gap-2 m-0 p-0 list-none">
            <li v-for="link in col.links" :key="link.label">
              <RouterLink
                v-if="link.to"
                :to="link.to"
                class="text-xs text-(--footer-text-dim) transition-colors duration-200 hover:text-(--footer-link-hover) no-underline"
              >
                {{ link.label }}
              </RouterLink>
              <a
                v-else
                :href="link.href"
                target="_blank"
                rel="noopener"
                class="text-xs text-(--footer-text-dim) transition-colors duration-200 hover:text-(--footer-link-hover) no-underline"
              >
                {{ link.label }}
              </a>
            </li>
          </ul>
        </div>
      </div>

      <!-- 底栏 -->
      <div class="border-t border-(--footer-border) pt-5 flex flex-col sm:flex-row items-center justify-between gap-2 text-[11px] text-(--footer-text-faint)">
        <div>&copy; 2024-2026 开放原子开源基金会 · 开源法律社区 FOSS LEGAL</div>
        <div class="text-(--footer-link-hover) font-medium">开放原子开源基金会 · 开源法律社区</div>
      </div>
    </div>
  </footer>
</template>
